import React from 'react';
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {ShowMoreClickEvent} from "../../models/show-more-click-event";
import {UseIoC} from "../composers/composer-plugins/use-ioc";

export const  ExpandableFooterShowMoreButtonComposer = () => (Component) => UseIoC()((props) => {
  const onClick = (e) => {
    if(props.source){
      const event: ShowMoreClickEvent = new ShowMoreClickEvent({
        source: props.source,
        gameId: props.gameId,
        isOpen: props.expanded
      });
      const analyticsService: AnalyticsService = props.ioc.getInstance(AnalyticsService);

      analyticsService.createEvent(event);
    }
    props.onClick && props.onClick(e)
  };

  return <Component {...props} onClick={(e) => onClick(e)}/>
});

